import React from 'react';

const Preloader = ({ message }) => {
    const isClient = typeof window !== 'undefined';
    const isAdmin = isClient && (window.location.pathname.startsWith('/admin') || window.location.pathname.startsWith('/superadmin'));
    
    const displayMessage = message || (isAdmin ? "Loading admin panel..." : "Discovering the world...");

    return (
        <div className="global-preloader">
            <div className="preloader-content">
                <div className="preloader-logo-wrapper">
                    {/* Ripple/pulse backgrounds */}
                    <div className="preloader-pulse-ring"></div>
                    <div className="preloader-pulse-ring-delayed"></div>
                    
                    {/* The Logo */}
                    <img 
                        src="/logo-mangoloops.png" 
                        alt="Mangoloops Logo" 
                        className="preloader-logo"
                    />
                </div>
                
                {/* A premium smooth line loader */}
                <div className="preloader-progress-container">
                    <div className="preloader-progress-bar"></div>
                </div>
                
                <h5 className="preloader-text mt-4 fw-semibold">{displayMessage}</h5>
            </div>
        </div>
    );
};

export default Preloader;
